import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Navbar from '../Navbar';
import Footer from '../Footer';
import IP_URL from '../connect';
import { Link } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Org from '@mui/icons-material/AccountBalance';
import GasMeterIcon from '@mui/icons-material/GasMeter';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import { useSelector } from 'react-redux';
import { selectUser } from '../../Redux/currentUserSlice';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Container = styled.div`
  width: 100vw;
  display: flex;
`;

const Content = styled.div`
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const Section = styled.div`
  padding: 20px;
  border-radius: 10px;
  background:  #0780d1ff;
  color: white;
  flex: 1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.5);
  }

  @media (max-width: 600px) {
    padding: 15px;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const P = styled.p`
  color: white;
  font-size: 20px;
  font-weight: bold;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.6);
`;

const SC = styled.div`
   margin:10px;
   border: 3px solid #128bdbff;
   padding:10px;
   border-radius:8px;
   font-weight:bold ;
   font-size:18px;
   text-align:center;
    color:#128bdbff;
    height:40px;
    display:flex;
    justify-content:center;
    align-items:center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
    }
 `
const View = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); 
  gap: 20px; 

`;

const AdminDashboard = () => {
  const [organizations, setOrganizations] = useState([]);
  const [meters, setMeters] = useState([]);
  const [ totalConsumption, setTotalConsumption ] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { token } = useSelector(selectUser);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  useEffect(() => {
    fetchOrganizations();
    fetchMeters();
    getTotalConsumption()
  }, []);

  const fetchOrganizations = async () => {
    try {
      const res = await fetch(`${IP_URL}/currentData/all-orgs/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) throw new Error("Failed to fetch organizations.");

      const data = await res.json();
      setOrganizations(data);
      toast.success("Organizations loaded successfully ✅",{
         position:"bottom-right" 
       
      });
    } catch (err) {
      toast.error(`Error: ${err.message}`);
    }
  };

  const fetchMeters = async () => {
    try {
      const res = await fetch(`${IP_URL}/currentData/all-meters/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) throw new Error("Failed to fetch meters.");

      const data = await res.json();
      setMeters(data);
      toast.success("Meters loaded successfully ✅",{
        position:"bottom-right"
      });
    } catch (err) {
      toast.error(`Error: ${err.message}`);
    }
  };
  
  //total Consumption
  const getTotalConsumption = async() => {
    try{
      const res = await fetch(`${IP_URL}/meter/total-consumption/`,{
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })
const data = await res.json();
      setTotalConsumption(data.total);
console.log("Total Consumption:", data);
    }catch(err){
      toast.error(`Error: ${err.message}`);
    }
  }
  const formatNumber = (num) => {
  if (!num || isNaN(num)) return "0.00";
  return parseFloat(num).toLocaleString("en-KE", { minimumFractionDigits: 2 });
};


  return (
    <Main>
      <Navbar showMenuButton={true} toggleSidebar={toggleSidebar} />
      <Container>
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      

        <Content>
         

          <StyledLink to='/organizations'>
            <Section>
              <Title>
                <Org sx={{ filter: "drop-shadow(0 0 4px rgba(0,0,0,0.8))" }} />
                <P>Organizations</P>
                <P> : {organizations.length}</P>
              </Title>
              
            </Section>
          </StyledLink>

          <StyledLink to='/meter-report'>
            <Section>
              <Title>
                <GasMeterIcon sx={{ filter: "drop-shadow(0 0 4px rgba(0,0,0,0.8))" }} />
                <P>Water Meters: {meters.length}</P>
              </Title>
              
            </Section>
          </StyledLink>

             <Section>
          <Title>
           
            <WaterDropIcon sx={{ filter: "drop-shadow(0 0 4px rgba(0,0,0,0.8))" }} />
             <P>Water Measured: </P> 
            </Title>
          <P>{formatNumber(totalConsumption)} litres</P>
        </Section>

        <View>
          <StyledLink to="/payments"><SC style={{borderColor: 'green', color: "green"}}>Payments</SC></StyledLink>
          <StyledLink to="/command-center"><SC>Command Center</SC></StyledLink>
          <StyledLink to='/map'><SC>Map View</SC></StyledLink>
          <StyledLink to='/admin-meter-data'><SC>Original Data</SC></StyledLink>
          <StyledLink to='/user-logs'><SC>Logs</SC></StyledLink>
        </View>
        </Content>
        
      </Container>

      <Footer />

    </Main>
  );
};

export default AdminDashboard;
